export { default } from './GroupingSummary';



// WEBPACK FOOTER //
// ./app/components/search/GroupingSummary/index.js